import React from 'react';
import { Link } from 'react-router-dom';
import { HiArrowRight } from 'react-icons/hi';
import Reveal from '../../../shared/Reveal/Reveal';
import { useInsightsPillarsContent } from '../../../../hooks/useInsightsPillarsContent';
import analysisIcon from '../../../../assets/images/insights/pillars/ic1.svg';
import newsIcon from '../../../../assets/images/insights/pillars/ic2.svg';
import calendarIcon from '../../../../assets/images/insights/pillars/ic3.svg';
import './Pillars.css';

const fallbackIcons = [analysisIcon, newsIcon, calendarIcon];

const Pillars = () => {
  const { content, isLoading } = useInsightsPillarsContent();

  if (isLoading || !content) {
    return null;
  }

  const { title, items } = content;

  return (
    <section className="insights-pillars">
      <div className="insights-pillars__inner">
        <Reveal>
          <h2 className="insights-pillars__title">{title}</h2>
        </Reveal>

        <div className="insights-pillars__grid">
          {items.map(({ title: itemTitle, text, cta, icon }, index) => (
            <Reveal key={itemTitle} delay={index * 80}>
              <article className="insights-pillars__card">
                <div className="insights-pillars__card-top">
                  <div className="insights-pillars__card-head">
                    <img
                      className="insights-pillars__icon"
                      src={icon || fallbackIcons[index] || analysisIcon}
                      alt=""
                      aria-hidden="true"
                    />
                    <h3 className="insights-pillars__card-title">{itemTitle}</h3>
                  </div>
                  <p className="insights-pillars__card-text">{text}</p>
                </div>

                {cta?.text && cta?.url ? (
                  <Link to={cta.url} className="insights-pillars__card-link">
                    {cta.text}
                    <HiArrowRight
                      className="insights-pillars__card-link-icon"
                      aria-hidden="true"
                    />
                  </Link>
                ) : null}
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Pillars;
